<template>
    <div class="nong-home-box">
        <div class="loader-ring" v-if="loading">
            <div class="loader-ring-light"></div>
            <div class="loader-ring-track"></div>
        </div>
        <div class="nong-home-boxs">
            <v-img
              v-for="(item, imgIndex) in img"
              :key="imgIndex"
              :class="
          index == imgIndex
            ? 'nong-home-img nong-home-img-first'
            : 'nong-home-img-list'
        "
              :src="item.picName"
              loading="lazy"
              aspect-ratio="1.7"
              @click="goWork(item.productId)"
              @load="aa()"
            >
            </v-img>
            <v-img
              v-if="img.length != 0"
              :src="img[index2].picName"
              class="nong-home-img-back"
              aspect-ratio="1.7"
              @click="goWork(item.productId)"
            >
            </v-img>
        </div>
        <div class="nong-home-boxs-h5">
            <v-img
              v-for="(item, imgIndex) in img"
              :key="imgIndex"
              loading="lazy"
              :class="
          index == imgIndex
            ? 'nong-home-img nong-home-img-first'
            : 'nong-home-img-list'
        "
              :src="item.picName"
              aspect-ratio="1.7"
            >
            </v-img>
            <v-img
              v-if="img.length != 0"
              :src="img[index2].picName"
              class="nong-home-img-back"
              aspect-ratio="1.7"
            >
            </v-img>
        </div>
    </div>
</template>

<script>
import { getBannerList } from "../../api/home";
export default {
    name: "home",
    computed: {},
    data() {
        return {
            img01Show: true,
            img02Show: true,
            timer: null,
            img: "",
            loading: true,
            index: 0,
            index2: 1,
            vaule: 0,
            isIosShow: false,
        };
    },
    watch: {},
    created() {
        this.$store.commit("setTheme", false);
        clearInterval(this.timer);
        this.timer = null;
        this.initImg();
    },
    methods: {
        goWork(id) {
            if (id == null) {
                return;
            } else {
                this.$router.push({
                    path: "/works/details",
                    // name: 'mallList',
                    query: {
                        id: id,
                    },
                });
            }
        },
        aa() {
            this.loading = false;
        },
        initData() {
            let that = this;
            // window.console.log(that.items)
            if (that.timer == null) {
                that.timer = setInterval(() => {
                    that.index = that.index + 1;
                    that.index2 = that.index2 + 1;
                    if (that.index == that.items.length) {
                        that.index = 0;
                    }
                    if (that.index2 == that.items.length) {
                        that.index2 = 0;
                    }
                }, 10000);
            }
        },
        initImg() {
            window.console.log("开始");

            getBannerList()
              .then((res) => {
                  if (res.errcode == 0) {
                      for (let i = 0; i < res.data.length; i++) {
                          res.data[i].picName = this.$ctx + res.data[i].picName;
                      }
                      this.items = res.data;
                      this.$store.commit(
                        "setTheme",
                        res.data[0].theme == 1 ? false : true
                      );
                      // window.console.log(res.data)
                      // this.img = res.data[0].picName
                      this.img = res.data;
                      window.console.log("结束");
                  } else {
                      window.console.log(res);
                  }
              })
              .catch((err) => {
                  window.console.log(err);
              });
            this.initData();
        },
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },
};
</script>

<style scoped>
@media screen and (min-width: 960px) {
    .nong-home-boxs-h5 {
        display: none;
    }

    .nong-home-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .nong-home-img-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        opacity: 0.1;
    }

    .nong-home-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        /*transition: all 12s;*/
        overflow-y: hidden;
        overflow-x: hidden;
        /*margin-right: 15%;*/
        animation-fill-mode: both; /*播放后的状态*/
        animation-iteration-count: infinite; /*动作循环的次数：infinite 无限循环*/
        animation-duration: 10s; /*动画时间*/
        animation-name: container;
    }

    @keyframes container {
        0% {
            opacity: 0.1;
            transform: scale(1);
        }
        20% {
            opacity: 1;
        }
        85% {
            opacity: 1;
            transform: scale(1.3);
        }
        100% {
            opacity: 0;
            transform: scale(1.3);
        }
    }

    .nong-home-img-first {
        z-index: 1;
    }

    .nong-home-boxs {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        position: relative;
        overflow-y: hidden;
        overflow-x: hidden;
    }

    .relative {
        position: relative;
    }

    .loader-ring {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -10px 0 0 -10px;
        width: 20px;
        height: 20px;
    }

    .loader-ring-light {
        width: 20px;
        height: 20px;
        -moz-border-radius: 20px;
        -webkit-border-radius: 20px;
        border-radius: 20px;
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;
        border-left: 1px solid #fff;
        border-right: 1px solid transparent;
        /* -moz-box-shadow: 0 1px 0 #fff inset;
      -webkit-box-shadow: 0 1px 0 #fff inset;
      box-shadow: 0 1px 0 #fff inset; */
        animation: rotate-360 1s linear infinite;
    }

    .loader-ring-track {
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        border-radius: 50%;

        /* -moz-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.3) inset;
      -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.3) inset;
      box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.3) inset; */
    }

    @keyframes rotate-360 {
        from {
            -moz-transform: rotate(0) scale(1);
            -ms-transform: rotate(0) scale(1);
            -webkit-transform: rotate(0) scale(1);
            transform: rotate(0) scale(1);
        }
        50% {
            -moz-transform: rotate(180deg) scale(1.2);
            -ms-transform: rotate(180deg) scale(1.2);
            -webkit-transform: rotate(180deg) scale(1.2);
            transform: rotate(180deg) scale(1.2);
        }
        to {
            -moz-transform: rotate(360deg) scale(1);
            -ms-transform: rotate(360deg) scale(1);
            -webkit-transform: rotate(360deg) scale(1);
            transform: rotate(360deg) scale(1);
        }
    }
}

@media screen and (max-width: 960px) {
    .nong-home-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .nong-home-img-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        opacity: 0.1;
    }

    .nong-home-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        /*transition: all 12s;*/
        overflow-y: hidden;
        overflow-x: hidden;
        /*margin-right: 15%;*/
        animation-fill-mode: both; /*播放后的状态*/
        animation-iteration-count: infinite; /*动作循环的次数：infinite 无限循环*/
        animation-duration: 10s; /*动画时间*/
        animation-name: container;
    }

    @keyframes container {
        0% {
            opacity: 0.1;
            transform: scale(1);
        }
        20% {
            opacity: 1;
        }
        85% {
            opacity: 1;
            transform: scale(1.3);
        }
        100% {
            opacity: 0;
            transform: scale(1.3);
        }
    }

    .nong-home-img-first {
        z-index: 1;
    }

    .nong-home-boxs-h5 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        position: relative;
        overflow-y: hidden;
        overflow-x: hidden;
    }

    .nong-home-boxs {
        display: none;
    }
}
</style>
